const CheckNotNull = Symbol("CheckNotNull");

class SlideProfile {
    src: string = '';
    action: string = '';

    constructor(src: string, action: string) {
        this.src = this[CheckNotNull](src) ? src : '';
        this.action = this[CheckNotNull](src) ? action : '';
    }

    private [CheckNotNull] = (value: string) => {
        if(value && value != null && value != 'null' && value.length > 0)
            return true;
        else
            return false;
    }
}
export default SlideProfile;